import React from "react";
import "./Button.scss";
import { Link } from "react-router-dom";

const TextButton = ({
  children, // Content to be displayed inside the button
  to = null, // Target route path (if null, renders as button instead of link)
  variant = "primary", // Button style variant (primary, secondary, etc.)
  size = "md", // Size of the button (sm, md, lg)
  disabled = false, // Whether the button is disabled
  icon: Icon = null, // Optional icon component to be displayed
  iconVariant = "primary", // Style variant for the icon
  className = "", // Additional CSS classes
  ...props // Additional props to be spread on the button/link
}) => {
  /* === Class Name Generation === */
  const classes = `textButton ${className} ${variant} ${size} ${
    disabled ? "disabled" : ""
  } ${Icon && "iconsIsSet"}`;
  /* === End Class Name Generation === */

  /* === Content Generation === */
  const content = (
    <>
      {Icon && <Icon size={size} className={iconVariant} />}
      {children}
    </>
  );
  /* === End Content Generation === */

  /* === Conditional Rendering Logic === */
  if (to) {
    if (disabled) {
      return (
        <span className={`${classes} disabledLink`} {...props}>
          {content}
        </span>
      );
    }
    return (
      <Link className={classes} to={to} disabled={disabled} {...props}>
        {content}
      </Link>
    );
  }

  return (
    <button className={classes} disabled={disabled} {...props}>
      {content}
    </button>
  );
  /* === End Conditional Rendering Logic === */
};

export default TextButton;
